// attribution/referral.js
//
// In-app referral: which shared Aluvo page brought this visitor here (today:
// a shared My Top Movies list). Unlike first-touch attribution it is
// last-touch — the most recent share link wins — and it expires after 30
// days. It rides along with the first-touch record on signup as
// `ref_type` / `ref_slug` (see services/authService.js), so the admin funnel
// can count "visitor registered" against the list that was shared. No PII:
// the slug is the public share slug.

const STORAGE_KEY = 'aluvo_referral';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;
const SLUG_RE = /^[a-z0-9-]{1,120}$/;

export function setReferral(type, slug, now = Date.now()) {
    if (!type || !SLUG_RE.test(String(slug || ''))) return;
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ref_type: type, ref_slug: slug, at: now }));
    } catch { /* storage blocked */ }
}

/** { ref_type, ref_slug } while fresh, else null. */
export function getReferral(now = Date.now()) {
    try {
        const raw = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
        if (!raw || !raw.ref_type || now - Number(raw.at || 0) > TTL_MS) return null;
        return { ref_type: raw.ref_type, ref_slug: raw.ref_slug };
    } catch { return null; }
}

export function clearReferral() {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch { /* ignore */ }
}
